import type { ShippingInfo } from '../../typings/payPal.types';
import { CountryCodeMapper } from '../country-code-mapper';
import parseName from '../parseName';
import type { DeliveryAddressInfo } from '../../typings/basket.types';

function retrievePayPalDeliveryDetails(shippingInfo?: ShippingInfo): DeliveryAddressInfo {
    const { firstName, lastName } = parseName(shippingInfo?.name?.full_name ?? '');

    const phone = shippingInfo?.phone_number?.national_number;
    const address1 = shippingInfo?.address?.address_line_1 ?? '';
    const address2 = shippingInfo?.address?.address_line_2;
    const zipCode = shippingInfo?.address?.postal_code ?? '';
    const country = shippingInfo?.address?.country_code;
    const stateAbbr = shippingInfo?.address?.admin_area_1;
    const city = shippingInfo?.address?.admin_area_2 ?? '';
    const countryId = CountryCodeMapper.GetCountryId(country ?? '');

    return {
        firstName,
        lastName,
        phone,
        address1,
        address2,
        zipCode,
        city,
        countryId,
        stateAbbr,
        countryIso: country,
    };
}

export default retrievePayPalDeliveryDetails;
